import styled from '@emotion/styled'

import Button from './Button'
import { Portal, createPortalContext } from './Portal'
import { ActionButtonsPortalContext } from 'layouts/DefaultLayout'

type Props = {
	formId: string
	isSubmitting: boolean
	hasErrors: boolean
	isDirty: boolean
	context?: ReturnType<typeof createPortalContext>
}

const Error = styled.span`
	${({ theme }) => theme.typography.caption};
	color: ${({ theme }) => theme.colorPalette.red[500]};
`

function ConfiguratorActionButtons({
	formId,
	isSubmitting,
	hasErrors,
	isDirty,
	context = ActionButtonsPortalContext,
}: Props) {
	return (
		<Portal context={context}>
			{isDirty && (
				<>
					{hasErrors && <Error>Fill in mandatory fields in highlighted sections.</Error>}
					<Button type="reset" kind="secondary" form={formId} disabled={isSubmitting}>
						Cancel
					</Button>

					<Button
						type="submit"
						kind="primary"
						form={formId}
						loading={isSubmitting}
						disabled={isSubmitting || hasErrors}
					>
						Save
					</Button>
				</>
			)}
		</Portal>
	)
}

export default ConfiguratorActionButtons
